import { Content } from '@backstage/core-components';
import { PageShareTitle } from '../../lib/shareTitle';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { getStoredFunMode, translate } from '../i18n';

/**
 * Kafka consumed-topics tab for Component entities.
 * Shown for all components; renders an empty state when the service has no
 * Kafka data (404 from /services/:name or empty consumes array). Using the
 * empty-state approach (no filter annotation required) keeps the tab discovery
 * self-contained — the Kafka backend is the source of truth for which
 * components consume topics, so we do not duplicate that signal in catalog
 * annotations.
 * Extension id: entity-content:kafka/service.
 */
export const serviceKafkaContent = EntityContentBlueprint.make({
  name: 'service',
  params: {
    path: '/kafka',
    // Non-component config (evaluated once at extension registration), so
    // this reads the fun-mode flag directly instead of the useT() hook — see
    // the i18n module's non-component-code note. "Kafka" is a brand name, so
    // its `en`/`fun` values are identical either way.
    title: translate('kafka.serviceKafkaContent.title', getStoredFunMode()),
    filter: {
      kind: 'component',
    },
    loader: () =>
      import('./ServiceKafkaCard').then(m => (
        <PageShareTitle title="Kafka">
          <Content>
            <m.ServiceKafkaCard />
          </Content>
        </PageShareTitle>
      )),
  },
});
